export const WEBSITE = 'https://mohammedehab.com';
export const GITHUB = 'https://github.com/TheGooner93';
export const LINKEDIN = 'https://www.linkedin.com/in/m0hammed-ehab/';